import { render, staticRenderFns } from "./InvitePeople.vue?vue&type=template&id=45f6269a&"
import script from "./InvitePeople.vue?vue&type=script&lang=js&"
export * from "./InvitePeople.vue?vue&type=script&lang=js&"
import style0 from "./InvitePeople.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports